module.exports = __webpack_public_path__ + "fonts/VetoSans-Bold.70e5da47.woff2";